import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { Col, Drawer, Input, Row, notification } from "antd";
import { UserPlaceholder, translate } from "utils/utils";
import { setBreadcrumb, setLoader, updateCrumb } from "store/actions";

import { DateTime } from "luxon";
import { Footer } from "screens";
import { Helmet } from "react-helmet";
import { Icons } from "components";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";

class Treatment extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			...this.props.patient,
			treatments: [],
			defaultDiagnostics: [],
			showDrawer: false
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;

		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.patients,
						route: "/patients"
					},
					{
						text: this.state.patient?.name || Strings.generic.loading,
						route: `/patients/${this.state.patient?._id || ""}`
					},
					{
						text: Strings.patients.treatment,
						route: `/patients/${this.state.patient?._id || ""}/treatment`
					}
				]
			}))
		);

		this.getData();
	}

	componentDidUpdate() {
		const { dispatch } = this.props;
		dispatch(updateCrumb());
	}

	async getData() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		await Promise.all([this.getDiagnostics(), this.getPatient()]);

		dispatch(setLoader(false));
	}

	async getPatient() {
		const { match } = this.props;
		const {
			params: { id, idTreatment }
		} = match;

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriPatients(id, idTreatment)
			});

			if (response.ok) {
				const { patients: patient } = response.data.results || {};
				this.setState({ patient, ...patient });
			} else {
				notification.error({
					message: Strings.sidebar.patients,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.patients,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async getDiagnostics() {
		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriSkills()
			});

			if (response.ok) {
				const { diagnosis } = response.data.results || {};
				this.setState({ defaultDiagnostics: diagnosis });
			} else {
				notification.error({
					message: Strings.sidebar.patients,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.patients,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async submitConsultation() {
		const { tempConsultation } = this.state;

		let response: any;
		try {
			response = await API.put({
				url: Endpoints.uriAppointments(`${tempConsultation?._id}/report`),
				data: {
					clinicalIntervention: tempConsultation?.clinicalIntervention,
					clinicalRecord: tempConsultation?.clinicalRecord,
					clinicalNotes: tempConsultation?.clinicalNotes,
					goalsNextConsultation: tempConsultation.goalsNextConsultation
				}
			});

			if (response.ok) {
				notification.success({
					message: Strings.sidebar.appointments,
					description: Strings.appointments.edited,
					placement: "bottomRight",
					duration: 5
				});

				this.setState({ tempConsultation: null, showDrawer: false }, () => this.getPatient());
			} else {
				notification.error({
					message: Strings.sidebar.appointments,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.appointments,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	renderDrawer() {
		const { showDrawer } = this.state;
		const { mobile } = this.props;

		return (
			<Drawer
				title={<h2 className="DrawerTitle">{Strings.appointments.editAppointment}</h2>}
				footer={
					<div className="DrawerFooter">
						<button
							className="DrawerFooterButton"
							onClick={() =>
								this.setState({
									tempConsultation: null,
									showDrawer: false
								})
							}
						>
							{Strings.appointments.cancel}
						</button>
						<button className="DrawerFooterButton --btn-primary" onClick={() => this.submitConsultation()}>
							{Strings.appointments.confirm}
						</button>
					</div>
				}
				className="drawer"
				width={mobile ? "100%" : 400}
				placement="right"
				closable={true}
				visible={showDrawer}
				onClose={() => this.setState({ showDrawer: false, tempConsultation: null })}
			>
				{this.renderDrawerContent()}
			</Drawer>
		);
	}

	renderDrawerContent() {
		const { tempConsultation } = this.state;

		return (
			<Row gutter={[0, 20]}>
				<Col xs={24}>
					<label htmlFor="report_record" className="InputLabel">
						{Strings.reports.report}
					</label>
					<Input.TextArea
						id="report_record"
						value={tempConsultation?.clinicalRecord || ""}
						className="TreatmentTextarea"
						rows={4}
						placeholder={Strings.reports.report}
						onChange={(e: any) => {
							const value = e.target.value;
							this.setState((prevState: any) => ({
								tempConsultation: { ...prevState.tempConsultation, clinicalRecord: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="report_notes" className="InputLabel">
						{Strings.reports.notes}
					</label>
					<Input.TextArea
						id="report_notes"
						value={tempConsultation?.clinicalNotes || ""}
						className="TreatmentTextarea"
						rows={4}
						placeholder={Strings.reports.notes}
						onChange={(e: any) => {
							const value = e.target.value;
							this.setState((prevState: any) => ({
								tempConsultation: { ...prevState.tempConsultation, clinicalNotes: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="report_intervention" className="InputLabel">
						{Strings.reports.intervention}
					</label>
					<Input.TextArea
						id="report_intervention"
						value={tempConsultation?.clinicalIntervention || ""}
						className="TreatmentTextarea"
						rows={4}
						placeholder={Strings.reports.intervention}
						onChange={(e: any) => {
							const value = e.target.value;
							this.setState((prevState: any) => ({
								tempConsultation: { ...prevState.tempConsultation, clinicalIntervention: value }
							}));
						}}
					/>
				</Col>
				<Col xs={24}>
					<label htmlFor="report_objectives" className="InputLabel">
						{Strings.reports.objectivesNextAppointment}
					</label>
					<Input.TextArea
						id="report_objectives"
						value={tempConsultation?.goalsNextConsultation || ""}
						className="TreatmentTextarea"
						rows={4}
						placeholder={Strings.reports.objectivesNextAppointment}
						onChange={(e: any) => {
							const value = e.target.value;
							this.setState((prevState: any) => ({
								tempConsultation: { ...prevState.tempConsultation, goalsNextConsultation: value }
							}));
						}}
					/>
				</Col>
			</Row>
		);
	}

	render() {
		const { patient, photo, defaultDiagnostics, treatments } = this.state;
		const { language, mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>
						{Strings.patients.treatments} - {Strings.sidebar.patients} -{" "}
						{patient?.name || Strings.generic.loading} | Team24
					</title>
					<meta name="description" content="Description of Treatment" />
				</Helmet>
				<div className="TreatmentContent">
					<div className="MultiTitle">
						<h1>{Strings.sidebar.appointments}</h1>
						<img className="TreatmentHeaderAvatar" src={photo || UserPlaceholder} alt="patient avatar" />
					</div>
					<div className="TreatmentList">
						{Array.isArray(treatments?.consultations) &&
							treatments?.consultations?.length > 0 &&
							treatments?.consultations.map((consultation: any, index: number) => {
								let diagnostic = Strings.generic.loading;
								if (consultation.diagnostics) {
									diagnostic = consultation.diagnostics
										.map((diagnostic: any) => {
											const diag = defaultDiagnostics.find(
												(tmp: any) => tmp._id === diagnostic
											)?.name;
											return translate(diag);
										})
										.join(", ");
								}

								return (
									<React.Fragment key={`treatment_consultation_${consultation._id}`}>
										<div className="TreatmentEntry">
											<div className="TreatmentHeader">
												<p className="TreatmentDate">
													{`${
														consultation.consultationIndexNumber
															? Strings.formatString(
																	Strings.generic.numeration as string,
																	consultation.consultationIndexNumber
															  ) + " | "
															: ""
													}${DateTime.fromISO(consultation.startDate)
														.setLocale(language)
														.toFormat("dd MMMM yyyy - HH:mm")}`}
													H
												</p>
												<button
													onClick={() =>
														this.setState({
															tempConsultation: JSON.parse(JSON.stringify(consultation)),
															showDrawer: true
														})
													}
												>
													<Icons.Pencil />
													<p>{Strings.fields.edit}</p>
												</button>
											</div>
											<h3>{diagnostic}</h3>
											{Boolean(consultation.clinicalRecord) && (
												<React.Fragment>
													<p className="TreatmentConsultationSubTitle">
														{Strings.reports.report}
													</p>
													<p>{consultation.clinicalRecord}</p>
												</React.Fragment>
											)}
											{Boolean(consultation.clinicalIntervention) && (
												<React.Fragment>
													<p className="TreatmentConsultationSubTitle">
														{Strings.reports.intervention}
													</p>
													<p>{consultation.clinicalIntervention}</p>
												</React.Fragment>
											)}
											{Boolean(consultation.goalsNextConsultation) && (
												<React.Fragment>
													<p className="TreatmentConsultationSubTitle">
														{Strings.reports.objectivesNextAppointment}
													</p>
													<p>{consultation.goalsNextConsultation}</p>
												</React.Fragment>
											)}
										</div>
										{index < treatments?.consultations?.length - 1 && (
											<div className="TreatmentEntrySeparator" />
										)}
									</React.Fragment>
								);
							})}
						{(!treatments?.consultations || treatments?.consultations?.length === 0) && (
							<p>{Strings.patients.noTreatments}</p>
						)}
					</div>
				</div>
				{mobile && <Footer />}
				{this.renderDrawer()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	mobile: state.mobile
});

export default connect(mapStateToProps)(Treatment);
